import React, { useState, forwardRef, useImperativeHandle, useContext, useEffect } from "react";
import filter_button from "./filter.png";
import SelectionComponent from "./SelectionComponent";
import { AppContext } from "../../../AppContext";
import { Table, Form, Modal } from "react-bootstrap";

export default forwardRef((props, ref) => {
    const { ignoredCategories, ignoredTags, setIgnoredTags, setIgnoredCategories,
        updateTransactionSimulation, simulatedTransactions, getTransactionSimulation, removeTransactionSimulation } = useContext(AppContext);
    const [lookups, setLookups] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState(ignoredCategories);
    const [selectedTags, setSelectedTags] = useState(ignoredTags);
    const [show, setShow] = useState(false);
    const [originalSimulationRecommendation, setOriginalSimulationRecommendation] = useState([]);
    const [simulationRecommendation, setSimulationRecommendation] = useState([]);
    const [selectedYear, setSelectedYear] = useState([]);
    const [selectedMonthId, setSelectedMonthId] = useState([]);

    const simulationTransactionsForTime = getTransactionSimulation(selectedYear, selectedMonthId);
    if (simulationTransactionsForTime) {
        simulationRecommendation.forEach((item) => {
            if (simulationTransactionsForTime[item.id]) {
                item.filtered = true;
            } else {
                item.filtered = false;
            }
        })
    }

    useEffect(() => {
        console.log(`useEffect [simulatedTransactions] - ${JSON.stringify(simulatedTransactions)}`)
    }, [simulatedTransactions])

    useEffect(() => {
        const potentialSimulationsToCancel = simulationRecommendation.filter((r) => selectedCategories.includes(r.categoryId))
        cancelSimulations(potentialSimulationsToCancel);

        setSimulationRecommendation(originalSimulationRecommendation.filter((r) => !selectedCategories.includes(r.categoryId)))
        console.log(`useEffect [selectedCategories]`)
    }, [selectedCategories])

    useImperativeHandle(ref, () => ({
        setLookups: (lookups) => {
            setLookups(lookups);

        },
        setSimulationRecommendation: (simulationRecommendation, selectedMonthId, selectedYear) => {
            setOriginalSimulationRecommendation(simulationRecommendation);
            setSimulationRecommendation(simulationRecommendation);
            setSelectedMonthId(selectedMonthId);
            setSelectedYear(selectedYear);

            const potentialSimulationsToCancel = simulationRecommendation.filter((r) => selectedCategories.includes(r.categoryId))
            cancelSimulations(potentialSimulationsToCancel);

            setSimulationRecommendation(simulationRecommendation.filter((r) => !selectedCategories.includes(r.categoryId)))
        }
    }));

    const cancelSimulations = (simulationsToCancel) => {
        simulationsToCancel.forEach((item)=>{
            removeTransactionSimulation({
                id: item.id,
                time: item.time
            });
        })
    }

    const handleToggle = () => {
        setShow(!show);
    };

    const handleClose = () => {
        setIgnoredCategories(selectedCategories);
        setIgnoredTags(selectedTags);
        setShow(false);
    };

    const handleTagChanged = (selectedTags) => {
        setSelectedTags(selectedTags);
    };

    const handleCategoryChange = (selectedCategories) => {
        setSelectedCategories(selectedCategories);
    };

    const filterChanged = (item) => {
        console.log(simulatedTransactions)
        const simulation = getTransactionSimulation(selectedYear, selectedMonthId);
        const shouldBeChecked = !simulation?.[item.id];
        if (shouldBeChecked) {
            updateTransactionSimulation({
                id: item.id,
                transactionType: item.transactionType,
                isCredit: item.amount > 0,
                originalAmount: item.amount,
                changedAmount: 0,
                time: item.time
            });
        } else {
            removeTransactionSimulation({
                id: item.id,
                time: item.time
            });
        }
    }

    return lookups && (
        <div>
            <img
                style={{ width: props.iconWidth || "45px", marginTop: "20px" }}
                src={filter_button}
                onClick={handleToggle}
            />
            <Modal
                style={{ right: 0, left: 0 }}
                show={show}
                centered
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Modal.Title>סנן</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: props.isMobile ? "column" : "row"
                        }}
                    >
                        <SelectionComponent
                            description={"קטגוריות"}
                            options={lookups.categories}
                            selectedItems={selectedCategories}
                            selectionCallback={handleCategoryChange}
                            isMobile={props.isMobile}
                        />
                        <SelectionComponent
                            description={"תגיות"}
                            options={lookups.tags}
                            selectedItems={selectedTags}
                            selectionCallback={handleTagChanged}
                            isMobile={props.isMobile}
                        />
                    </div>
                    <div style={{ marginTop: "30px", overflowY: "auto", maxHeight: "500px" }}>
                        <h3 style={{ textAlign: "center" }}>המלצות סינון</h3>
                        <Table dir="rtl" style={{ width: "80%", height: "200px", margin: "auto" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "150px" }}>תיאור</th>
                                    <th style={{ width: "100px" }}>קטגוריה</th>
                                    <th style={{ width: "100px" }}>סוג</th>
                                    <th style={{ width: "200px" }}>הערות</th>
                                    <th style={{ width: "100px" }}>סכום</th>
                                    <th style={{ width: "100px" }}>סנן</th>
                                </tr>
                            </thead>
                            <tbody>
                                {simulationRecommendation.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{ verticalAlign: "middle" }}>{item.description}</td>
                                            <td style={{ verticalAlign: "middle" }}>{lookups.categories.find((c) => c.id === item.categoryId)?.description || `קטגוריה ${item.categoryId}  לא נמצאה`}</td>
                                            <td style={{ verticalAlign: "middle" }}>{item.creditcard ? `אשראי` : 'בנק'}</td>
                                            <td style={{ verticalAlign: "middle" }}>{item.remarks}</td>
                                            <td style={{ verticalAlign: "middle", verticalAlign: "middle", direction: "ltr", textAlign: "right" }}>{item.amount}</td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <Form.Switch checked={item.filtered} onChange={() => filterChanged(item)} ></Form.Switch>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
});
